import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ESIInclude from "@JohnLewisPartnership/jl-esi-components";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import esiSourceWrapper from "@/constants/esiSourceWrapper";
import { getSolutionContactDetailsByTag } from "@/utils/data/getContactDetails";
import styles from "./screens.module.scss";
import SolutionBrandSupportViewContactDetail from "./SolutionBrandSupportViewContactDetail";

function SolutionBrandSupport({ esiSource, brand }) {
  const [supplierContactConfig, setSupplierContactConfig] = useState(null);

  useEffect(() => {
    getSolutionContactDetailsByTag(`returningAnItem-small-faulty-no-${brand.toLowerCase()}`).then(config =>
      setSupplierContactConfig(config),
    );
  }, []);

  return (
    <div className={styles.landingPageSolutionContainer}>
      <div className={styles.solutionESIContainer}>
        <ESIInclude src={esiSourceWrapper(esiSource)} id="content" />
      </div>
      {supplierContactConfig ? (
        <div>
          <h2>Contact {brand} Technical support</h2>
          <p>Please have the product with you when you call.</p>
          <SecondaryButton tag="a" href={`tel:${supplierContactConfig.phone.supplierNumber}`} className={styles.button}>
            {supplierContactConfig.phone.supplierNumber}
          </SecondaryButton>
        </div>
      ) : (
        <LoadingSpinner />
      )}
      <div className={styles.solutionViewContactDetailsContainer}>
        <div className={styles.orSeparator}>
          <span>OR</span>
        </div>
      </div>
      <SolutionBrandSupportViewContactDetail supplierContactConfig={supplierContactConfig} />
    </div>
  );
}

SolutionBrandSupport.propTypes = {
  esiSource: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export default SolutionBrandSupport;
